import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const AddRoomsPanel = () => {
  const [RoomsData, setRoomsData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_all_room_types"
      );
      setRoomsData(response.data.data);
    };

    fetchData();
  }, []);

  // room number
  const [RoomNumber, setRoomNumber] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/room_number_list"
      );
      setRoomNumber(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_room_number",
        { room_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        setRoomNumber((prevUser) =>
          prevUser.filter((user) => user.room_id !== userId)
        );
        toast.error("Data Deleted Successfully!");
        navigate("/Master/AddRooms");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  const [selectedRoomType, setSelectedRoomType] = useState("");

  // Handle dropdown change
  const handleRoomTypeChange = (e) => {
    setSelectedRoomType(e.target.value);
  };

  // Filtered data based on selection
  const filteredRooms = selectedRoomType
    ? RoomNumber.filter((room) => room.room_type_name === selectedRoomType)
    : RoomNumber;

  return (
    <div className="container mt-5">
      <table className="table table-bordered table-striped">
        <thead className="">
          <tr>
            <th colSpan="3" className=" text-center bg-white text-black fs-4">
              Rooms Types Table
            </th>
          </tr>
          <tr>
            <th className="text-white text-center table-custom">Room Types</th>
            <th className="text-white text-center table-custom">Descreption</th>
            <th className="text-white text-center table-custom">Actions</th>
          </tr>
        </thead>
        <tbody>
          {RoomsData.map((Rooms, index) => (
            <tr key={index}>
              <td className="text-center">
                <strong>{Rooms.room_type_name}</strong>
              </td>
              <td className="text-center">{Rooms.room_desp}</td>
              <td className="text-center">
                <Link to={`/Master/AddRooms-edit/${Rooms.room_type_id}`}>
                  <button className="btn btn-primary btn-sm me-1">
                    <i className="fa-regular fa-pen-to-square text-white"></i>
                  </button>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="col-md-12 mb-3 d-flex justify-content-between align-items-center mt-5">
        <div className="w-50">
          <label className="mb-2">Room Types</label>
          <select
            className="form-control"
            value={selectedRoomType}
            onChange={handleRoomTypeChange}
          >
            <option value="">Select Room Type</option>
            {RoomsData.map((roomno) => (
              <option key={roomno.room_type_id} value={roomno.room_type_name}>
                {roomno.room_type_name}
              </option>
            ))}
          </select>
        </div>

        <div className="add-btn">
          <Link to="/Master/AddRooms-add">
            <button className="btn btn-success text-white">Add Rooms</button>
          </Link>
        </div>
      </div>

      <table className="table table-bordered table-striped">
        <thead className="">
          <tr>
            <th colSpan="4" className="text-center bg-white text-black fs-4">
              Rooms Number Table
            </th>
          </tr>
          <tr>
            <th className="text-white text-center table-custom">Room Type</th>
            <th className="text-white text-center table-custom">Room Number</th>
            <th className="text-white text-center table-custom">Images</th>
            <th className="text-white text-center table-custom">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRooms.map((RoomNo, index) => (
            <tr key={index}>
              <td className="text-center">
                <strong>{RoomNo.room_type_name}</strong>
              </td>
              <td className="text-center">{RoomNo.room_number}</td>
              <td className="text-center">
                {RoomNo.room_image && RoomNo.room_image.length > 0 && (
                  <img
                    src={`https://cyberathon.com/silverapartment/${RoomNo.room_image[0]}`}
                    alt="Room"
                    style={{ width: "100px", height: "auto" }}
                  />
                )}
              </td>
              <td className="text-center">
                <Link to={`/Master/AddRooms-editdata/${RoomNo.room_id}`}>
                  <button className="btn btn-info btn-sm me-1">
                    <i className="fa-regular fa-pen-to-square text-white"></i>
                  </button>
                </Link>
                <button
                  className="btn btn-danger btn-sm me-1"
                  onClick={() => deleteUser(RoomNo.room_id)}
                >
                  <i className="fa-regular fa-trash-can text-white"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const RoomAdd = () => {
  const initialState = {
    room_type_id: "",
    room_type_name: "",
    room_number: "",
  };

  const [RoomUser, setRoomUser] = useState(initialState);
  const [RoomImages, setRoomImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [RoomsData, setRoomsData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_all_room_types"
      );
      setRoomsData(response.data.data);
    };

    fetchData();
  }, []);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to array

    // Add new images to previous images
    setRoomImages((prevImages) => [...prevImages, ...files]);

    const newPreviews = files.map((file) => URL.createObjectURL(file));

    // Add new previews to previous previews
    setPreviewImages((prevPreviews) => [...prevPreviews, ...newPreviews]);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("room_number", RoomUser.room_number);
    formData.append("room_type_id", RoomUser.room_type_id);
    formData.append("room_type_name", RoomUser.room_type_name);

    RoomImages.forEach((image) => {
      formData.append("room_image[]", image); // ✅ Very important: use []
    });

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_room_number",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === 1) {
        toast.success(response.data.message || "Room added successfully!");
        setRoomUser(initialState);
        setRoomImages([]);
        setPreviewImages([]);
        navigate("/Master/AddRooms");
      } else {
        toast.error(response.data.message || "Failed to add room");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header bg-dark text-white">
          <h4 className="mb-0 text-center">Add Room</h4>
        </div>

        <div className="card-body">
          <form className="row g-3" onSubmit={submitForm}>
            <div className="col-md-6">
              <label htmlFor="room_type_id" className="form-label">
                Room Types
              </label>
              <select
                className="form-control"
                id="room_type_id"
                name="room_type_id"
                value={RoomUser.room_type_id}
                onChange={(e) => {
                  const selected = RoomsData.find(
                    (room) => room.room_type_id === e.target.value
                  );
                  setRoomUser({
                    ...RoomUser,
                    room_type_id: e.target.value,
                    room_type_name: selected?.room_type_name || "",
                  });
                }}
              >
                <option value="">Select Room Type</option>
                {RoomsData.map((room) => (
                  <option key={room.room_type_id} value={room.room_type_id}>
                    {room.room_type_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label htmlFor="room_number" className="form-label">
                Room Number
              </label>
              <input
                type="text"
                className="form-control"
                id="room_number"
                name="room_number"
                placeholder="Enter Room Number"
                value={RoomUser.room_number}
                onChange={(e) =>
                  setRoomUser({ ...RoomUser, room_number: e.target.value })
                }
              />
            </div>

            <div className="col-md-12">
              <label htmlFor="room_image" className="form-label">
                Room Images (you can select multiple)
              </label>
              <input
                type="file"
                className="form-control"
                id="room_image"
                accept="image/*"
                multiple
                onChange={handleImageChange}
              />

              <div className="d-flex flex-wrap gap-2 mt-2">
                {previewImages.map((src, index) => (
                  <img
                    key={index}
                    src={src}
                    alt={`Preview ${index + 1}`}
                    style={{
                      width: "100px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                ))}
              </div>
            </div>

            <div className="col-12 d-flex justify-content-end ">
              <button
                type="submit"
                className="btn btn-succes text-white"
                style={{ height: "40px" }}
              >
                Add Room
              </button>
              <div className="mb-3 ps-2">
                <Link to="/Master/AddRooms" className="btn btn-secondary">
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditRoomImage = () => {
  const [roomImages, setRoomImages] = useState([]);
  const [updatedImages, setUpdatedImages] = useState([]);

  const navigate = useNavigate();
  const { id } = useParams(); // room_id from route
  console.log("Editing Room ID:", id);

  // Fetch existing images
  useEffect(() => {
    axios
      .post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_room_number_by_id",
        { room_id: id }
      )
      .then((res) => {
        console.log("API Response:", res.data);
        console.log("Room Image Raw:", res.data.data.room_image);

        if (res.data.success === "1" || res.data.success === 1) {
          const images = res.data.data.room_image || [];
          console.log("Parsed Images:", images);
          setRoomImages(images);
        } else {
          toast.error("Failed to load room images");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error fetching room images");
      });
  }, [id]);

  const handleFileChange = (index, file) => {
  setUpdatedImages((prev) => {
    const newImages = [...prev];
    newImages[index] = file;
    return newImages;
  });
};


  // Submit form
const submitForm = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append("room_id", id);

  const existingImages = [];

  roomImages.forEach((oldImg, index) => {
    if (updatedImages[index]) {
      // If user selected a new file → send as file
      formData.append("room_image[]", updatedImages[index]);
    } else {
      // Keep track of existing image path
      existingImages.push(oldImg);
    }
  });

  // Send old image paths as JSON string
  formData.append("existing_images", JSON.stringify(existingImages));

  try {
    const response = await axios.post(
      "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_room_number",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    console.log("Update Response:", response.data);

    if (String(response.data.success) === "1") {
      toast.success(response.data.message || "Images updated successfully");
      navigate("/Master/AddRooms");
    } else {
      toast.error(response.data.message || "Failed to update images");
    }
  } catch (error) {
    console.error("Axios Error:", error);
    toast.error("Error updating images");
  }
};




  // Build full image URL
  const getImageSrc = (img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `https://cyberathon.com/silverapartment/${img}`;
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Edit Room Images</h5>
            </div>

            <div className="modal-body">
              {roomImages.length > 0 ? (
                roomImages.map((img, index) => (
                  <div key={index} className="mb-4">
                    <p>Image {index + 1}</p>
                    <img
                      src={
                        updatedImages[index]
                          ? URL.createObjectURL(updatedImages[index])
                          : getImageSrc(img)
                      }
                      alt={`Room ${index + 1}`}
                      style={{
                        width: "150px",
                        display: "block",
                        marginBottom: "10px",
                        border: "1px solid #ccc",
                        padding: "5px",
                      }}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => handleFileChange(index, e.target.files[0])}
                    />
                  </div>
                ))
              ) : (
                <p>Loading images...</p>
              )}
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/Master/AddRooms">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};


export const ViewRoom = () => {
  const [RoomUser, setRoomUser] = useState({
    room_image: [],
    room_type_name: "",
    room_number: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const RoomData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_room_number_by_id",
          {
            room_id: id,
          }
        );

        const data = response.data.data;

        // Handle room_image parsing
        let parsedImages = [];
        if (typeof data.room_image === "string") {
          try {
            parsedImages = JSON.parse(data.room_image);
          } catch (e) {
            console.error("Error parsing room_image:", e);
          }
        } else if (Array.isArray(data.room_image)) {
          parsedImages = data.room_image;
        }

        setRoomUser({
          ...data,
          room_image: parsedImages,
        });
      } catch (error) {
        console.error("There was an error!", error);
      }
    };

    RoomData();
  }, [id]);

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between">
        <h2 className="mb-4">View Room</h2>

        <Link to="/Master/AddRooms" className="btn m-2">
          <button type="button" className="back-btn">
            Back
          </button>
        </Link>
      </div>
      <h3 className="mt-3">
        {RoomUser.room_type_name} {RoomUser.room_number}
      </h3>

      <div className="card p-3">
        <Link to={`/Master/AddRooms-editimage/${RoomUser.room_id}`}>
          <button className="btn btn-primary btn-sm m-2">
            <i className="fa-regular fa-pen-to-square text-white"></i> Edit
            Image
          </button>
        </Link>
        {RoomUser.room_image.length > 0 ? (
          RoomUser.room_image.map((image, index) => (
            <div key={index} className="mb-3">
              <img
                src={`https://cyberathon.com/silverapartment/${image}`}
                alt={`Room Image ${index + 1}`}
                className="img-fluid rounded mb-2"
                style={{ maxWidth: "400px" }}
              />
              {/* Image Edit Button */}
            </div>
          ))
        ) : (
          <p>No images available.</p>
        )}
      </div>
    </div>
  );
};

export const EditRoomType = () => {
  const [RoomTypeUser, setRoomTypeUser] = useState({
    room_type_name: "",
    room_desp: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setRoomTypeUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const RoomTypeInfoData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_room_type_by_id`,
          {
            room_type_id: id,
          }
        );
        setRoomTypeUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    RoomTypeInfoData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const payload = {
      room_type_id: id,
      room_type_name: RoomTypeUser.room_type_name,
      room_desp: RoomTypeUser.room_desp,
    };

    console.log("Sending Payload:", payload); // Debugging

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_room_type",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response.data);

      if (response.data.success === "1") {
        toast.info(response.data.message || "Data updated successfully");
        navigate("/Master/AddRooms");
      } else {
        toast.error(response.data.message || "Failed to update Room Type");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        paddingBottom: 50,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Edit Room Type</h5>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Room Type</label>
                <input
                  type="text"
                  value={RoomTypeUser.room_type_name}
                  onChange={changeHandler}
                  className="form-control"
                  name="room_type_name"
                  id="room_type_name"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Room Description</label>
                <textarea
                  rows={5}
                  type="text"
                  value={RoomTypeUser.room_desp}
                  onChange={changeHandler}
                  className="form-control"
                  name="room_desp"
                  id="room_desp"
                />
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <Link to="/Master/AddRooms">
                <button
                  type="button"
                  className="btn btn-secondary ms-1"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-success">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
